import { render } from "./ResourcesGoal3e.vue?vue&type=template&id=191b7fc9"
import script from "./ResourcesGoal3e.vue?vue&type=script&lang=js"
export * from "./ResourcesGoal3e.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__